import type { RANKING_CRITERIA } from "@data/studios";
import styles from "./CriteriaSection.module.css";

interface CriteriaSectionProps {
  criteria: typeof RANKING_CRITERIA;
}

export function CriteriaSection({ criteria }: CriteriaSectionProps) {
  return (
    <section className={styles.section} id="criteria" aria-labelledby="criteria-heading">
      <div className="container">
        <div className={styles.heading}>
          <p className={styles.eyebrow}>Transparent methodology</p>
          <h2 id="criteria-heading">How we assess each studio</h2>
          <p>
            We compare every studio across the same five criteria and describe how it
            does in plain language—Exceptional, Excellent, Strong, or Solid—rather than
            inventing precise numeric scores. Some criteria carry more weight in our
            overall ranking than others.
          </p>
        </div>
        <div className={styles.grid}>
          {criteria.map((item) => (
            <article key={item.key} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3>{item.label}</h3>
                <span className={styles.weight}>{item.emphasis}</span>
              </div>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
